import { fileKeyFacet } from '../Schema/Facets';
import { getParameterStore } from '../store/ParametersStore';
import { AttachmentModel, lazyGetAttachment } from 'owa-attachment-model-store';
import { openInNewTab, isDownloadAllowed, download } from 'owa-attachment-user-operations';
import LinkAttachment from 'owa-service/lib/contract/LinkAttachment';
import { ReferenceAttachmentModel } from 'owa-attachment-model-store';
import { PreviewPaneSelectionSource, SxSCustomization, sxsStore } from 'owa-sxs-store';
import { lazySetRightPaneDisplayAndUpdateSize } from 'owa-sxsdata';
import * as React from 'react';
import {
    connectToItemCache,
    IItemCache,
    IItemOpenUrlActionProps,
    IActionProps,
    Action,
    IDefaultClickActionHandler,
    Facet,
    IDefaultClickActionHandlerProps,
    defaultClickActionControl,
    openDefaultClickActionHandler,
} from '@ms/items-view';
import {
    lazyPreviewAttachmentInSxS,
    SxSReadingPaneInitializeMethod,
    SxSReadingPaneStrategy,
} from 'owa-attachment-preview-sxs-actions';
import { AttachmentOpenAction, getAttachmentDefaultOpenAction } from 'owa-attachment-data';
import { getAttachmentViewStateStore } from '../store/AttachmentViewStateStore';

export const ItemClickItemAction = connectToItemCache(
    (
        itemCache: IItemCache,
        props: IItemOpenUrlActionProps
    ): Pick<IActionProps, 'isAvailable' | 'engagement' | 'onExecute'> => {
        const { itemKey } = props;

        const { id, conversationId, conversationSubject } = itemCache.demandItemFacet(
            fileKeyFacet,
            itemKey
        );

        const parameterStore = getParameterStore();

        return {
            isAvailable: !!id,
            onExecute: id
                ? async () => {
                      const attachmentId = {
                          Id: id,
                          mailboxInfo: parameterStore.mailboxInfo,
                      };

                      const getAttachment = await lazyGetAttachment.import();
                      const attachment: AttachmentModel = getAttachment(attachmentId);

                      const attachmentViewState = getAttachmentViewStateStore().attachmentViewStates.get(
                          attachmentId.Id
                      );

                      switch (getAttachmentDefaultOpenAction(attachmentViewState.strategy)) {
                          case AttachmentOpenAction.Preview:
                              let readingPaneStrategy: SxSReadingPaneStrategy = {
                                  method: SxSReadingPaneInitializeMethod.AlwaysHidden,
                              };

                              if (conversationId) {
                                  readingPaneStrategy = {
                                      method:
                                          SxSReadingPaneInitializeMethod.LoadConversationReadingPane,
                                      conversationId: {
                                          Id: conversationId,
                                          mailboxInfo: parameterStore.mailboxInfo,
                                      },
                                      conversationSubject: conversationSubject,
                                      conversationCategories: [],
                                  };
                              }

                              lazySetRightPaneDisplayAndUpdateSize
                                  .import()
                                  .then(setRightPaneDisplayAndUpdateSize => {
                                      setRightPaneDisplayAndUpdateSize(sxsStore.viewState, 1);
                                  });

                              lazyPreviewAttachmentInSxS.importAndExecute(
                                  attachmentViewState,
                                  attachmentId,
                                  false,
                                  false,
                                  PreviewPaneSelectionSource.ConsumerGroupFilesHub,
                                  null, // createImageGallery
                                  readingPaneStrategy,
                                  null, //TODO figure out if I need this (instrumentationContext)
                                  SxSCustomization.GroupFilesHub
                              );
                              break;
                          case AttachmentOpenAction.Download:
                              if (isDownloadAllowed(attachment.model)) {
                                  download(attachmentId, attachment.model);
                              }
                              break;
                          case AttachmentOpenAction.OpenInNewTab:
                              if ((attachment as ReferenceAttachmentModel).openUrl) {
                                  openInNewTab((attachment as ReferenceAttachmentModel).openUrl);
                              } else if ((attachment.model as LinkAttachment).WebUrl) {
                                  openInNewTab((attachment.model as LinkAttachment).WebUrl);
                              }
                              break;
                          default:
                              break;
                      }
                  }
                : undefined,
            engagement: {
                name: 'ClickItem',
                isIntentional: true,
                scenario: parameterStore.scenarioName,
            },
        };
    }
)(Action);

export const clickItemDefaultClickActionHandler: IDefaultClickActionHandler = {
    key: new Facet('clickItemDefaultClickActionHandler').id,
    evaluate: (itemCache: IItemCache, props: IDefaultClickActionHandlerProps) => {
        const { itemKey } = props;

        return {
            action: <ItemClickItemAction itemKey={itemKey} />,
        };
    },
};

export function defaultClickActionControlHandler(
    itemCache: IItemCache,
    props: typeof defaultClickActionControl.inputType
): typeof defaultClickActionControl.returnType {
    const { handlers } = props;

    return {
        handlers: [
            openDefaultClickActionHandler,
            clickItemDefaultClickActionHandler,
            ...(handlers || []),
        ],
    };
}
